export default __webpack_public_path__ + "static/media/talLondon.90ffc376.jpg";